import axios from '../index'

function uploadEditorImage(formdata) {
	return axios({
				method: "post",
				url: "/api/s3/uploadEditorImage",
				header: { 'Content-Type': 'multipart/form-data' },
				data: formdata
			});
}
export default {
	uploadEditorImage,

}
